import TimeIcon from '@mui/icons-material/AccessTime';
import PhoneCallbackIcon from '@mui/icons-material/PhoneCallback';
import CallIcon from '@mui/icons-material/PhoneForwarded';
import WebIcon from '@mui/icons-material/Public';
import { Chip, Tooltip } from '@mui/material';
import { ucWords } from "utility/helpers";
// Use a map to store the values for titles, colors, and icons
const callTypes = {
    'inbound-web': { tooltip: 'Web Call', color: 'rgb(125 102 217)', icon: <WebIcon sx={{color: 'rgb(125 102 217) !important' }} /> },
    'inbound-phone': { tooltip: 'Incoming Call', color: 'green', icon: <PhoneCallbackIcon sx={{color: 'green !important' }} /> },
    'outbound-phone': { tooltip: 'Outgoing Call', color: 'orange', icon: <CallIcon sx={{color: 'orange !important' }} /> },
};

const CallTypeIcon = ({ value, type = '', include_type=false, ...props }) => {
    // Get the tooltip, color, and icon from the map based on the call type
    const { tooltip, color, icon } = callTypes[type] || { tooltip: 'Unknown', color: 'gray', icon: null };
    return (
        <Tooltip title={tooltip} arrow sx={{ backgroundColor: 'green !important', fontSize: '0.5rem' }} {...props}>
        <Chip
            icon={icon}
            label={value ? (include_type ? value + ' (' + tooltip +')' : value) : tooltip}
            variant="outlined"
            sx={{ borderColor: color}}
            />
        </Tooltip>
    );
}
const Duration = ({ value, ...props }) => {
    // Get the title, color, and icon from the map based on the call type
    return (
        <Tooltip {...props}>
            <Chip
                icon={<TimeIcon />}
                label={value}
                variant="outlined"
            />
        </Tooltip >
    );
}
const NA = ({ title = 'N/A' }) => {
    return (
        <small>{title}</small>
    );
};

const Status = ({ value = '', ...props }) => {
    if (value == null) {
        value = 'N/A';
    }
    if (value == 'N/A') {
        return NA(value);
    }
    let color = 'secondary';
    let variant = 'outlined';
    let fontColor = '';
    value = value.toLowerCase().trim();
    switch (value) {
        case 'fail':
            color = 'error';
            break;
        case 'pass':
            color = 'success';
            break;
        case 'call in progress':
            color = 'success';
            variant = 'filled';
            break;
        case 'customer-ended-call':
            color = 'success';
            variant = 'outlined';
            break;
        case 'assistant-ended-call-with-hangup-task':
        case 'assistant-forwarded-call':
        case 'assistant-ended-call':
            color = 'info';
            variant = 'outlined';
            break;
        case 'silence-timed-out':
        case 'exceeded-max-duration':
            color = 'warning';
            variant = 'outlined';
            break;
        default:
            if (value.includes('failed') || value.includes('error')) {
                color = 'error';
                variant = 'outlined';
            }
    }
    
    // Replace "assistant" with "agent"
    value = value.replace('assistant', 'agent');

    // Set font color for filled variant
    fontColor = variant === 'filled' ? 'white !important' : '';
    return (
        <Tooltip {...props}>
            <Chip label={ucWords(value)} color={color} variant={variant} sx={{
                fontWeight: 400, color: fontColor
            }} />
        </Tooltip>
    );
};
export default CallTypeIcon;
export { Duration, NA, Status };

